module.exports = __webpack_public_path__ + "img/gsb5.20123079.png";